import { Component, OnInit } from '@angular/core';
import { HandlerService } from '../handler.service';
import { ApiService } from '../api.service';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manage-item-category',
  templateUrl: './manage-item-category.component.html',
  styleUrls: ['./manage-item-category.component.scss'],
})
export class ManageItemCategoryComponent {

  loader: boolean = true;
  category;
  name;
  search:any=[];
  filterLength;
  img;
  constructor(    private router: Router,  public handler: HandlerService, private platform: Platform,
    public service: ApiService) { }
ionViewWillEnter(){
  this.getCategory();
}
getCategory(){
  this.service.getAllDetailedPurchaseCategory().subscribe((res: any) => {
    if(res){
      this.category=res;
      this.img = res.img;
      this.name=res.name;
      this.loader = false;
    }else{
      this.handler.res("No Data Found");
      this.loader = false;
    }
    
  },err=>{
    this.handler.err(err);
    this.loader=false;
  })
}

deleteCategories(id){
  this.loader=true;
  this.service.deletePurchaseCategory(id).subscribe(res=>{
    this.loader=false;
    this.handler.res("Deleted successfully")
    this.getCategory(); 
    this.router.navigate(['/manage-items-Category'])
  },
  err=>{
    this.handler.err(err)
    this.loader=false
  })
}  

route(id){
  this.router.navigate(['edit-purchaseCategory/', +id]);
}

refreshData(event){
  this.loader = true; 
  this.ionViewWillEnter();
  setTimeout(() => {
    event.target.complete();
  }, 1000);
}

ionViewWillLeave(){
  this.search="";
}
clear(){
  this.search="";
}
ngDoCheck(): void {
  this.filterLength = sessionStorage.getItem('len')
}
}